"use client"

import * as React from "react"
import { DesktopContextMenu } from "@/components/desk/DesktopContextMenu"
import { WallpaperModal } from "@/components/desk/WallpaperModal"
import { AddAppModal } from "@/components/modules/AddAppModal"
import { WidgetLibraryModal } from "@/components/widgets/WidgetLibraryModal"
import { RenameAppModal } from "@/components/modules/RenameAppModal"
import { AddWidgetModal } from "@/components/widgets/AddWidgetModal"
import { MobileControlCenter } from "@/components/mobile/MobileControlCenter"
import { MobileNotifications } from "@/components/mobile/MobileNotifications"
import { MobileAppSwitcher } from "@/components/mobile/MobileAppSwitcher"
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog"
import { NotificationCenterPanel } from "@/components/desk/NotificationCenterPanel"
import { FloatingWidgetContainer } from "@/components/widgets/FloatingWidgetContainer"
import { PinnedEarHandles } from "@/components/desk/PinnedWidgetsPanel"
import { MacDock } from "@/components/desk/MacDock"
import { SwitchAccountModal } from "@/components/auth/SwitchAccountModal"
import { MobileTaskBar } from "@/components/mobile/MobileTaskBar"
import { AuthAppConsentModal } from "@/components/auth/AuthAppConsentModal"
import { TermsAcceptanceModal } from "@/components/auth/TermsAcceptanceModal"

interface WorkspaceOverlaysProps {
  contextMenu: { x: number; y: number; visible: boolean }
  setContextMenu: React.Dispatch<React.SetStateAction<{ x: number; y: number; visible: boolean }>>
  showWallpaperModal: boolean
  setShowWallpaperModal: (show: boolean) => void
  showAddAppModal: boolean
  setShowAddAppModal: (show: boolean) => void
  showAddWidgetToDesktopModal: boolean
  setShowAddWidgetToDesktopModal: (show: boolean) => void
  desktopIconSize?: any
  setDesktopIconSize?: any
  user: any
  desktopWallpaper: string
  setDesktopWallpaper: (val: string) => void
  mobileWallpaper: string
  setMobileWallpaper: (val: string) => void
  useSeparateMobileWallpaper: boolean
  setUseSeparateMobileWallpaper: (val: boolean) => void
  wallpaperTab: "desktop" | "mobile"
  setWallpaperTab: (tab: "desktop" | "mobile") => void
  customWallpapers: string[]
  setCustomWallpapers: React.Dispatch<React.SetStateAction<string[]>>
  handleSaveWallpaperToDb: any
  installedApps: any[]
  hiddenAppIds: string[]
  setHiddenAppIds: React.Dispatch<React.SetStateAction<string[]>>
  showWidgetLibraryModal: boolean
  setShowWidgetLibraryModal: (show: boolean) => void
  widgetsConfig: any[]
  setWidgetsConfig: React.Dispatch<React.SetStateAction<any[]>>
  renamingAppId: string | null
  setRenamingAppId: (id: string | null) => void
  renamingAppInput: string
  setRenamingAppInput: (input: string) => void
  handleSaveRenameApp: any
  showMobileControlCenter: boolean
  setShowMobileControlCenter: (show: boolean) => void
  accounts: any[]
  currentAccount: any
  lang: any
  setLang: (lang: any) => void
  theme: string
  setTheme: (theme: string) => void
  notifications: any[]
  setNotifications: React.Dispatch<React.SetStateAction<any[]>>
  handleLogout: any
  handleSwitchAccount: any
  handleOpenProfileTab: any
  setProfileTab: (tab: any) => void
  handleOpenSettingsTab: any
  setShowMobileNotifications: (show: boolean) => void
  showMobileNotifications: boolean
  showMobileAppSwitcher: boolean
  setShowMobileAppSwitcher: (show: boolean) => void
  openApps: any[]
  setActiveAppId: (id: string | null) => void
  handleCloseApp: (id: string) => void
  handleCloseAllApps?: () => void
  switcherOffsets: Record<string, number>
  handleSwitcherTouchStart: any
  handleSwitcherTouchMove: any
  handleSwitcherTouchEnd: any
  revokingApiKeyId: string | null
  setRevokingApiKeyId: (id: string | null) => void
  handleRevokeApiKey: (id: string) => void
  revokingAppId: string | null
  setRevokingAppId: (id: string | null) => void
  handleRevokeApp: (id: string) => void
  showNotificationCenter: boolean
  setShowNotificationCenter: (show: boolean) => void
  handleGenerateRealNotification: any
  activeFloatingWidgets: string[]
  floatingPositions: any
  floatingSizes: any
  setFloatingPositions: any
  setFloatingSizes: any
  minimizedWidgets: Set<string>
  handleFocusFloatingWidget: any
  handleDragWidget: any
  handleMinimizeWidget: any
  handlePinWidget: any
  handleToggleFloatingWidget: (id: string) => void
  calcFocusedWidgetId: string | null
  setCalcFocusedWidgetId: (id: string | null) => void
  calcFormula: string
  setCalcFormula: (formula: any) => void
  calcDisplay: string
  setCalcDisplay: (display: any) => void
  showCalcHistory: boolean
  setShowCalcHistory: (show: any) => void
  calcHistory: any[]
  setCalcHistory: (history: any) => void
  setCalcResetOnNext: React.Dispatch<React.SetStateAction<boolean>>
  handleCalcPress: (val: string) => void
  calendarDate: Date | undefined
  setCalendarDate: (date: Date | undefined) => void
  notesContent: string
  setNotesContent: (val: string) => void
  activeAppId: string | null
  isDockVisible: boolean
  setIsDockVisible: (visible: boolean) => void
  dockPosition: any
  dockOrientation: any
  dockAlignment: any
  dockNoMargin: boolean
  dockSize: number
  setDockSize: (size: number) => void
  dockAppIds: string[]
  setDockAppIds: React.Dispatch<React.SetStateAction<string[]>>
  dockWidgetIds: string[]
  handleDockAppClick: any
  handleOpenMarketplaceTab: any
  setSettingsTab: (tab: any) => void
  setSplitActiveAppId: (id: string | null) => void
  handleDockDragStart: any
  isSwitchAccountOpen: boolean
  setIsSwitchAccountOpen: (open: boolean) => void
  t: any
  handleMobileBack: any
  authAppToShow: any
  setAuthAppToShow: (app: any) => void
  handleToggleGlobalApp: any
  marketplaceApps: any[]
  globallyInstalledApps: string[]
  setGloballyInstalledApps: React.Dispatch<React.SetStateAction<string[]>>
  hasCheckedTermsCheckbox: boolean
  setHasCheckedTermsCheckbox: (checked: boolean) => void
  isAcceptingTerms: boolean
  handleAcceptTerms: any
  pinnedWidgets: string[]
  pinnedWidgetSides: Record<string, "left" | "right" | "top">
  setPinnedWidgetSides: React.Dispatch<React.SetStateAction<Record<string, "left" | "right" | "top">>>
  collapsedSides: Record<"left" | "right" | "top", boolean>
  setCollapsedSides: React.Dispatch<React.SetStateAction<Record<"left" | "right" | "top", boolean>>>
  sideWidths: Record<"left" | "right", number>
  setSideWidths: React.Dispatch<React.SetStateAction<Record<"left" | "right", number>>>
  topPanelHeight: number
  setTopPanelHeight: React.Dispatch<React.SetStateAction<number>>
  weatherInfo: string
  showToast?: (title: string, desc: string, variant?: any) => void
}

export function WorkspaceOverlays({
  contextMenu,
  setContextMenu,
  showWallpaperModal,
  setShowWallpaperModal,
  showAddAppModal,
  setShowAddAppModal,
  showAddWidgetToDesktopModal,
  setShowAddWidgetToDesktopModal,
  desktopIconSize,
  setDesktopIconSize,
  user,
  desktopWallpaper,
  setDesktopWallpaper,
  mobileWallpaper,
  setMobileWallpaper,
  useSeparateMobileWallpaper,
  setUseSeparateMobileWallpaper,
  wallpaperTab,
  setWallpaperTab,
  customWallpapers,
  setCustomWallpapers,
  handleSaveWallpaperToDb,
  installedApps,
  hiddenAppIds,
  setHiddenAppIds,
  showWidgetLibraryModal,
  setShowWidgetLibraryModal,
  widgetsConfig,
  setWidgetsConfig,
  renamingAppId,
  setRenamingAppId,
  renamingAppInput,
  setRenamingAppInput,
  handleSaveRenameApp,
  showMobileControlCenter,
  setShowMobileControlCenter,
  accounts,
  currentAccount,
  lang,
  setLang,
  theme,
  setTheme,
  notifications,
  setNotifications,
  handleLogout,
  handleSwitchAccount,
  handleOpenProfileTab,
  setProfileTab,
  handleOpenSettingsTab,
  setShowMobileNotifications,
  showMobileNotifications,
  showMobileAppSwitcher,
  setShowMobileAppSwitcher,
  openApps,
  setActiveAppId,
  handleCloseApp,
  handleCloseAllApps,
  switcherOffsets,
  handleSwitcherTouchStart,
  handleSwitcherTouchMove,
  handleSwitcherTouchEnd,
  revokingApiKeyId,
  setRevokingApiKeyId,
  handleRevokeApiKey,
  revokingAppId,
  setRevokingAppId,
  handleRevokeApp,
  showNotificationCenter,
  setShowNotificationCenter,
  handleGenerateRealNotification,
  activeFloatingWidgets,
  floatingPositions,
  floatingSizes,
  setFloatingPositions,
  setFloatingSizes,
  minimizedWidgets,
  handleFocusFloatingWidget,
  handleDragWidget,
  handleMinimizeWidget,
  handlePinWidget,
  handleToggleFloatingWidget,
  calcFocusedWidgetId,
  setCalcFocusedWidgetId,
  calcFormula,
  setCalcFormula,
  calcDisplay,
  setCalcDisplay,
  showCalcHistory,
  setShowCalcHistory,
  calcHistory,
  setCalcHistory,
  setCalcResetOnNext,
  handleCalcPress,
  calendarDate,
  setCalendarDate,
  notesContent,
  setNotesContent,
  activeAppId,
  isDockVisible,
  setIsDockVisible,
  dockPosition,
  dockOrientation,
  dockAlignment,
  dockNoMargin,
  dockSize,
  setDockSize,
  dockAppIds,
  setDockAppIds,
  dockWidgetIds,
  handleDockAppClick,
  handleOpenMarketplaceTab,
  setSettingsTab,
  setSplitActiveAppId,
  handleDockDragStart,
  isSwitchAccountOpen,
  setIsSwitchAccountOpen,
  t,
  handleMobileBack,
  authAppToShow,
  setAuthAppToShow,
  handleToggleGlobalApp,
  marketplaceApps,
  globallyInstalledApps,
  setGloballyInstalledApps,
  hasCheckedTermsCheckbox,
  setHasCheckedTermsCheckbox,
  isAcceptingTerms,
  handleAcceptTerms,
  pinnedWidgets,
  pinnedWidgetSides,
  setPinnedWidgetSides,
  collapsedSides,
  setCollapsedSides,
  sideWidths,
  setSideWidths,
  topPanelHeight,
  setTopPanelHeight,
  weatherInfo,
  showToast
}: WorkspaceOverlaysProps) {
  return (
    <>
      {/* Modais e Menu de Contexto do Desktop */}
      <DesktopContextMenu
        contextMenu={contextMenu}
        onClose={() => setContextMenu((prev) => ({ ...prev, visible: false }))}
        onOpenWallpaper={() => setShowWallpaperModal(true)}
        onOpenAddApp={() => setShowAddAppModal(true)}
        onOpenAddWidget={() => setShowAddWidgetToDesktopModal(true)}
        desktopIconSize={desktopIconSize}
        setDesktopIconSize={setDesktopIconSize}
      />
      <WallpaperModal
        isOpen={showWallpaperModal}
        onClose={() => setShowWallpaperModal(false)}
        user={user}
        desktopWallpaper={desktopWallpaper}
        setDesktopWallpaper={setDesktopWallpaper}
        mobileWallpaper={mobileWallpaper}
        setMobileWallpaper={setMobileWallpaper}
        useSeparateMobileWallpaper={useSeparateMobileWallpaper}
        setUseSeparateMobileWallpaper={setUseSeparateMobileWallpaper}
        wallpaperTab={wallpaperTab}
        setWallpaperTab={setWallpaperTab}
        customWallpapers={customWallpapers}
        setCustomWallpapers={setCustomWallpapers}
        handleSaveWallpaperToDb={handleSaveWallpaperToDb}
      />
      <AddAppModal
        isOpen={showAddAppModal}
        onClose={() => setShowAddAppModal(false)}
        installedApps={installedApps}
        hiddenAppIds={hiddenAppIds}
        setHiddenAppIds={setHiddenAppIds}
      />
      <WidgetLibraryModal
        isOpen={showWidgetLibraryModal}
        onClose={() => setShowWidgetLibraryModal(false)}
        installedApps={installedApps}
        hiddenAppIds={hiddenAppIds}
        setHiddenAppIds={setHiddenAppIds}
        widgetsConfig={widgetsConfig}
        setWidgetsConfig={setWidgetsConfig}
      />
      <RenameAppModal
        renamingAppId={renamingAppId}
        onClose={() => setRenamingAppId(null)}
        renamingAppInput={renamingAppInput}
        setRenamingAppInput={setRenamingAppInput}
        handleSaveRenameApp={handleSaveRenameApp}
      />
      <AddWidgetModal
        isOpen={showAddWidgetToDesktopModal}
        onClose={() => setShowAddWidgetToDesktopModal(false)}
        widgetsConfig={widgetsConfig}
        setWidgetsConfig={setWidgetsConfig}
      />
      <MobileControlCenter
        isOpen={showMobileControlCenter}
        onClose={() => setShowMobileControlCenter(false)}
        user={user}
        accounts={accounts}
        currentAccount={currentAccount}
        lang={lang}
        setLang={setLang}
        theme={theme || "dark"}
        setTheme={setTheme}
        notifications={notifications}
        handleLogout={handleLogout}
        handleSwitchAccount={handleSwitchAccount}
        handleOpenProfileTab={handleOpenProfileTab}
        setProfileTab={(tab: string) => setProfileTab(tab as any)}
        handleOpenSettingsTab={handleOpenSettingsTab}
        setShowWallpaperModal={setShowWallpaperModal}
        setShowAddAppModal={setShowAddAppModal}
        setShowMobileNotifications={setShowMobileNotifications}
      />
      <MobileNotifications
        isOpen={showMobileNotifications}
        onClose={() => setShowMobileNotifications(false)}
        notifications={notifications}
        setNotifications={setNotifications}
        theme={theme}
      />
      <MobileAppSwitcher
        isOpen={showMobileAppSwitcher}
        onClose={() => setShowMobileAppSwitcher(false)}
        openApps={openApps}
        setActiveAppId={setActiveAppId}
        handleCloseApp={handleCloseApp}
        handleCloseAllApps={handleCloseAllApps}
        switcherOffsets={switcherOffsets}
        handleSwitcherTouchStart={handleSwitcherTouchStart}
        handleSwitcherTouchMove={handleSwitcherTouchMove}
        handleSwitcherTouchEnd={handleSwitcherTouchEnd}
        theme={theme}
      />

      {/* AlertDialog para revogar API Key */}
      <AlertDialog open={!!revokingApiKeyId} onOpenChange={(open) => !open && setRevokingApiKeyId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Revogar Chave de API?</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza de que deseja revogar permanentemente esta chave de API? Qualquer aplicativo ou serviço que utilize esta chave perderá o acesso imediatamente.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                if (revokingApiKeyId) {
                  handleRevokeApiKey(revokingApiKeyId)
                  setRevokingApiKeyId(null)
                }
              }}
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              Confirmar Revogação
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* AlertDialog para revogar Developer App */}
      <AlertDialog open={!!revokingAppId} onOpenChange={(open) => !open && setRevokingAppId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Revogar Aplicativo?</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza de que deseja revogar permanentemente este aplicativo? Todos os tokens de acesso gerados para ele perderão o acesso imediatamente.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                if (revokingAppId) {
                  handleRevokeApp(revokingAppId)
                  setRevokingAppId(null)
                }
              }}
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              Confirmar Revogação
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* CENTRAL DE NOTIFICAÇÕES (Estilo macOS / Apple com Blur Fading Claro) */}
      <NotificationCenterPanel
        isOpen={showNotificationCenter}
        onClose={() => setShowNotificationCenter(false)}
        notifications={notifications}
        setNotifications={setNotifications}
        handleGenerateRealNotification={handleGenerateRealNotification}
      />

      {/* SISTEMA DE WIDGETS FLUTUANTES ARRASTÁVEIS (Apenas na Área de Trabalho) */}
      {activeAppId === null && (
        <FloatingWidgetContainer
          activeFloatingWidgets={activeFloatingWidgets}
          widgetsConfig={widgetsConfig}
          floatingPositions={floatingPositions}
          floatingSizes={floatingSizes}
          setFloatingPositions={setFloatingPositions}
          setFloatingSizes={setFloatingSizes}
          minimizedWidgets={minimizedWidgets}
          handleFocusFloatingWidget={handleFocusFloatingWidget}
          handleDragWidget={handleDragWidget}
          handleMinimizeWidget={handleMinimizeWidget}
          handlePinWidget={handlePinWidget}
          handleToggleFloatingWidget={handleToggleFloatingWidget}
          calcFocusedWidgetId={calcFocusedWidgetId}
          setCalcFocusedWidgetId={setCalcFocusedWidgetId}
          theme={theme}
          lang={lang}
          pinnedWidgets={pinnedWidgets}
          pinnedWidgetSides={pinnedWidgetSides}
          setPinnedWidgetSides={setPinnedWidgetSides}
          setCollapsedSides={setCollapsedSides}
          calcFormula={calcFormula}
          setCalcFormula={setCalcFormula}
          calcDisplay={calcDisplay}
          setCalcDisplay={setCalcDisplay}
          showCalcHistory={showCalcHistory}
          setShowCalcHistory={setShowCalcHistory}
          calcHistory={calcHistory}
          setCalcHistory={setCalcHistory}
          setCalcResetOnNext={setCalcResetOnNext}
          handleCalcPress={handleCalcPress}
          calendarDate={calendarDate}
          setCalendarDate={setCalendarDate}
          notesContent={notesContent}
          setNotesContent={setNotesContent}
        />
      )}

      {/* ORELHAS COMPACTAS DISCRETAS QUANDO RECOLHIDO (APENAS NAS ABAS DOS APPS, NÃO NO DESK) */}
      {activeAppId !== null && (
        <PinnedEarHandles
          pinnedWidgets={Array.from(new Set([...(pinnedWidgets || []), ...(activeFloatingWidgets || [])]))}
          widgetsConfig={widgetsConfig}
          pinnedWidgetSides={pinnedWidgetSides}
          collapsedSides={collapsedSides}
          setCollapsedSides={setCollapsedSides}
        />
      )}

      {/* DOCK ESTILO macOS */}
      <MacDock
        activeAppId={activeAppId}
        isDockVisible={isDockVisible}
        setIsDockVisible={setIsDockVisible}
        dockPosition={dockPosition}
        dockOrientation={dockOrientation}
        dockAlignment={dockAlignment}
        dockNoMargin={dockNoMargin}
        dockSize={dockSize}
        setDockSize={setDockSize}
        dockAppIds={dockAppIds}
        setDockAppIds={setDockAppIds}
        dockWidgetIds={dockWidgetIds}
        installedApps={installedApps}
        widgetsConfig={widgetsConfig}
        openApps={openApps}
        activeFloatingWidgets={activeFloatingWidgets}
        lang={lang}
        handleDockAppClick={handleDockAppClick}
        handleToggleFloatingWidget={handleToggleFloatingWidget}
        handleOpenMarketplaceTab={handleOpenMarketplaceTab}
        handleOpenSettingsTab={handleOpenSettingsTab}
        handleOpenProfileTab={handleOpenProfileTab}
        setProfileTab={setProfileTab}
        setSettingsTab={setSettingsTab}
        setActiveAppId={setActiveAppId}
        setSplitActiveAppId={setSplitActiveAppId}
        handleDockDragStart={handleDockDragStart}
        hiddenAppIds={hiddenAppIds}
        setHiddenAppIds={setHiddenAppIds}
        setShowAddAppModal={setShowAddAppModal}
        hasCompany={Boolean(currentAccount && accounts && accounts.length > 0)}
      />

      {/* MODAL DE TROCAR CONTA */}
      <SwitchAccountModal
        isOpen={isSwitchAccountOpen}
        onClose={() => setIsSwitchAccountOpen(false)}
        accounts={accounts}
        currentAccount={currentAccount}
        onSwitchAccount={handleSwitchAccount}
        t={t}
      />

      {/* BARRA DE NAVEGAÇÃO / TAREFAS DO CELULAR */}
      <MobileTaskBar
        activeAppId={activeAppId}
        setActiveAppId={setActiveAppId}
        openApps={openApps}
        showMobileAppSwitcher={showMobileAppSwitcher}
        setShowMobileAppSwitcher={setShowMobileAppSwitcher}
        showMobileControlCenter={showMobileControlCenter}
        setShowMobileControlCenter={setShowMobileControlCenter}
        handleMobileBack={handleMobileBack}
      />

      {/* GOOGLE-LIKE AUTHORIZATION / CONSENT MODAL */}
      <AuthAppConsentModal
        authAppToShow={authAppToShow}
        onClose={() => setAuthAppToShow(null)}
        onAuthorize={async (appToAuth) => {
          const appId = appToAuth.id;
          const slug = appToAuth.slug;
          await handleToggleGlobalApp(appId, "install");
          
          if (slug === "bold-crm") {
            const contactsApp = marketplaceApps.find(a => a.slug === "bold-contacts" || a.slug === "contacts" || a.name.toLowerCase().includes("contato"));
            if (contactsApp) {
              await handleToggleGlobalApp(contactsApp.id, "install");
            }
          }
          
          setAuthAppToShow(null);
        }}
      />
    </>
  )
}
